<template>
  <section class="insurance-card template__content__align-between">
    <section class="insurance-card__data">
      <div v-if="isInsuranceUpdated">
        <v-alert text="Convênio alterado com sucesso." type="success" />

        <hr class="insurance-card__data__divider" />
      </div>

      <h2 class="insurance-card__data__subtitle h2 color--grey-10">
        <p>Confirme os dados da sua carteirinha</p>
      </h2>

      <HealthInsuranceCard class="insurance-card__data__card" />

      <div class="insurance-card__data__link" @click="goToLinkParams">
        <p>Informar novo convênio</p>
      </div>
    </section>

    <section class="insurance-card__actions flex flex-wrap flex-justify-content--center">
      <VButton text="Confirmar convênio" @click.native="checkInsuranceAuth" />

      <VButton
        text="Não usar convênio"
        variant="secondary"
        @click.native="
          () => {
            updatePaymentToPrivate();
          }
        "
      />
    </section>
  </section>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import store from '@/store';
import { step } from '@/utils/enums/googleAnalytics';
import insuranceAuthorizerController from '@/utils/helpers/rulesController/insuranceAuthorizerRule.js';
import VAlert from '@/components/commons/VAlert';
import HealthInsuranceCard from '@/components/payments/HealthInsuranceCard.component';
import { cardDetails, dataLayersMixin, updatePaymentToPrivate } from '@/utils/mixins';
import { handlePaymentMixin } from '@/utils/mixins/handlePayment.mixin';
import { PRIVATE_PAYMENT_BASE } from '@/utils/constants/payment.constants';

export default {
  name: 'InsuranceCard',
  mixins: [cardDetails, dataLayersMixin, updatePaymentToPrivate, handlePaymentMixin],
  components: {
    VAlert,
    HealthInsuranceCard,
  },
  data: () => ({
    defaultStep: 'end_flow_success',
  }),
  computed: {
    ...mapGetters({
      userFirstName: 'global/userFirstName',
      getUnitId: 'getBrandUnitIdVariables',
      haveScheduledExams: 'haveScheduledExams',
      isScheduledAdmission: 'global/isScheduledAdmission',
      isT2FlowAllowed: 'global/isT2FlowAllowed',
      isFlowStartedWithPaymentChoice: 'global/isFlowStartedWithPaymentChoice',
    }),
    ...mapState({
      currentAdmission: (state) => state.currentAdmission.data,
      paymentType: (state) => state.currentAdmission.data.payments[0],
      isInsuranceUpdated: (state) => state.healthInsurance.data.updateStatus,
    }),
    routerLinkParams() {
      return {
        name: 'change-insurance',
        params: {
          path: 'cliente',
          header: {
            hidePreviousBtn: false,
            title: 'Escolha seu convênio',
          },
        },
      };
    },
  },
  async created() {
    (await !this.paymentType?.uuid) && this.goNextStep('payment_type_choice');
  },

  methods: {
    ...mapActions(['global/updateFlowSteps', 'checkAndSetT2Flow']),

    goToLinkParams() {
      const linkParams = {
        name: 'change-insurance',
        params: {
          path: 'cliente',
          header: {
            hidePreviousBtn: false,
            title: 'Escolha seu convênio',
          },
        },
      };

      this.$router.push(linkParams);
    },
    async checkInsuranceAuth() {
      this['global/updateFlowSteps']([4, 2]);

      await this.checkAndSetT2Flow();

      if (this.isFlowStartedWithPaymentChoice) {
        return this.goNextStep('exams_add');
      }

      this.goNextStep('end_flow_success');
    },
    async isInsuranceDataEligible() {
      const insuranceCode = this.paymentType.clientId;
      const unitId = this.getUnitId.unitId;

      const isInsuranceDataEligible = await insuranceAuthorizerController(insuranceCode, unitId);

      return !!isInsuranceDataEligible;
    },
    async updatePaymentToPrivate() {
      await this.handlePayment_mixin(PRIVATE_PAYMENT_BASE);

      await this.checkAndSetT2Flow();

      if (this.isScheduledAdmission) {
        const hoursDifference = await this.returnHoursDifference(new Date(), this.examDate);
        if (this.isT2FlowAllowed && hoursDifference > 2) {
          this.goNextStep('queue_end_flow');
        } else if (this.isT2FlowAllowed && hoursDifference <= 2) {
          this.goNextStep('end_flow_success');
        } else {
          this.goNextStep('admission_done');
        }
      } else {
        this.goNextStep('end_flow_success');
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === 'questions') {
      // eslint-disable-next-line
      dataLayer.push({
        ...step.PAYMENT_CHOICE_STARTED,
        tipoAgendamento: store.getters.haveScheduledExams.label,
      });
    }

    next();
  },
};
</script>

<style lang="scss" scoped>
.insurance-card {
  &__data {
    &__divider {
      margin: 12px 0;
    }

    &__subtitle {
      font-size: 16px;
      letter-spacing: 0.005em;
      margin-bottom: 24px;
      text-align: left;

      p {
        font-weight: var(--font-weight-bold);
      }
    }

    &__card {
      margin-bottom: 30px;
    }

    &__link {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 50px;

      p {
        text-decoration: underline;
        color: var(--color-primary);
      }
    }
  }

  &__actions {
    :first-child {
      margin-bottom: 12px;
    }

    :nth-child(2) {
      background-color: transparent;
      border-color: transparent;
      color: var(--color-primary);
    }
  }
}
</style>
